<template>
  <div>
    <div class="row q-mb-md">
      <q-tabs
        v-model="selectedFee"
        dense
        class="bg-primary text-white shadow-2 q-mr-lg"
        align="left"
      >
      <q-tab
        :name="FEE_TYPES.general.name"
        :label="FEE_TYPES.general.label"
      />
      <q-tab
        :name="FEE_TYPES.additional.name"
        :label="FEE_TYPES.additional.label"
      />
      </q-tabs>
    </div>
    <div class="row q-mb-md">
      <q-tab-panels v-model="selectedFee" animated>
        <q-tab-panel :name="FEE_TYPES.general.name">
          <app-general-modifiers />
        </q-tab-panel>
        <q-tab-panel :name="FEE_TYPES.additional.name">
          <app-additional-modifiers />
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </div>
</template>

<script>
import AppGeneralModifiers from './general-modifiers';
import AppAdditionalModifiers from './additional-modifiers';

const FEE_TYPES = {
  general: {
    name: 'general',
    label: 'General'
  },
  additional: {
    name: 'additional',
    label: 'Additional Modifiers'
  }
};

export default {
  name: 'Fees',
  metaInfo: {
    title: 'AutoBook Pro - Fees'
  },
  components: {
    AppGeneralModifiers,
    AppAdditionalModifiers
  },
  data() {
    return {
      FEE_TYPES,
      selectedFee: FEE_TYPES.general.name
    };
  }
};
</script>

<style scoped>
  .distance-fee-type-labels{
    text-transform:capitalize
  }
</style>
